<label class="nu-checkbox {{size}}">
    <input type="checkbox" value="{{value}}" (change)="checkboxToggle($event)" [checked]="checked">
    <span class="nu-checkbox-checkmark"></span>
    {{label}}
</label>